<template>
  <div class="allReplybox">
    <div class="allReplyList_top">
      <div class="allReplyList_top_back" @click="backClick"></div>
      <div>{{ contentObj.floorNum }}楼回复</div>
    </div>
    <div class="allReplyList message">
      <div class="messageCon">
        <div class="userInfo">
          <div class="userInfo_left" @click="goUserPage(contentObj.memberId)">
            <img :src="contentObj.memberAvatar" @error="defImg()" alt="" />
            <div
              class="userInfo_leftbox_img_icon"
              :class="
                contentObj.memberAuthInfo && contentObj.isOfficial == 0
                  ? 'memberAuthInfoFlag'
                  : ''
              "
              v-show="
                contentObj.isOfficial == 1 ||
                contentObj.isOfficial == 2 ||
                contentObj.memberAuthInfo
              "
            ></div>
            <div class="messageCon_userbox">
              <div class="username">
                <div>{{ contentObj.memberNickName }}</div>
                <levelIcon :level="contentObj.memberExpLevel"></levelIcon>
                <div
                  class="auth_icon"
                  v-if="
                    contentObj.memberAuthInfo &&
                    contentObj.isOfficial != 1 &&
                    $store.state.gameType != 2
                  "
                >
                  {{ contentObj.memberAuthInfo }}
                </div>
                <span
                  class="messageCon_poster"
                  v-show="contentObj.memberId == postsPosterId"
                  >楼主</span
                >
              </div>

              <p class="message_floor">{{ contentObj.floorNum }}楼</p>
            </div>
          </div>
          <div
            class="details_comments_top_extension"
            @click="vanActionFlag(contentObj)"
          >
            ...
          </div>
        </div>
        <div class="messageCon_content">
          <label for="allReplybox_replyCon">
            <p
              class="msg"
              @click="toInputFocus(contentObj, 'poster')"
              v-html="contentObj.content"
            ></p>
          </label>
          <div class="messageCon_bottom">
            <p class="msgTime">{{ contentObj.createTime }}</p>
            <div class="messageCon_bottom_iconbox">
              <div class="likeWrap" @click="lickClick(contentObj)">
                <!-- <p></p> -->
                <div
                  class="card_lickbtn"
                  :class="
                    contentObj.isLike
                      ? 'publicAction_curgoodicon'
                      : 'publicAction_goodicon'
                  "
                  ref="allReplybox_lickbtn"
                ></div>
                <div class="messageCon_bottom_iconbox_licknum">
                  {{ contentObj.likeNum != 0 ? contentObj.likeNum : '' }}
                </div>
              </div>
              <div
                class="stepWrap"
                @click="badClick(contentObj)"
                :class="contentObj.isBad ? 'onstepWrap' : ''"
              >
                <p></p>
              </div>
              <!-- <div class="commentsWrap" @click="inputFocus(contentObj, 1)">
                <p></p>
                {{ contentObj.replyNum }}
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="allReplyList_replytitle">回复 {{ contentObj.replyNum }}</div>
      <div class="allReplyList_reply" v-swipeup="(e) => vueTouch('上滑', e)">
        <!-- 下滑加载 -->
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="messageCon"
            v-for="(item, index) in likeMemberAvators"
            :key="item.id"
          >
            <div class="userInfo">
              <div class="userInfo_left">
                <img
                  :src="item.memberAvatar"
                  @error="defImg()"
                  alt=""
                  @click="goUserPage(item.memberId)"
                />
                <div
                  class="userInfo_leftbox_img_icon"
                  :class="
                    item.memberAuthInfo && item.isOfficial == 0
                      ? 'memberAuthInfoFlag'
                      : ''
                  "
                  v-show="
                    item.isOfficial == 1 ||
                    item.isOfficial == 2 ||
                    item.memberAuthInfo
                  "
                ></div>
                <div class="messageCon_userbox" @click="toInputFocus(item)">
                  <div class="username">
                    <span
                      :class="
                        item.replyMemberNickName
                          ? ''
                          : 'messageCon_userbox_span'
                      "
                      >{{ item.memberNickName }}
                    </span>
                    <span
                      class="messageCon_poster"
                      v-show="item.memberId == postsPosterId"
                      >楼主</span
                    >
                    <span
                      class="messagereply_user_right"
                      v-show="item.replyMemberNickName"
                      >&nbsp; 回复 {{ item.replyMemberNickName }}</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="details_comments_top_extension"
                @click="vanActionFlag(item)"
              >
                ...
              </div>
            </div>
            <div class="messageCon_content">
              <label for="allReplybox_replyCon">
                <p
                  class="msg"
                  @click="toInputFocus(item)"
                  v-html="item.content"
                ></p>
              </label>
              <div class="messageCon_bottom">
                <p class="msgTime">{{ item.createTime }}</p>
                <div class="messageCon_bottom_iconbox">
                  <div
                    class="likeWrap allReplyboxList"
                    @click="lickClick(item, index)"
                  >
                    <!-- <p></p> -->
                    <div
                      class="card_lickbtn"
                      :class="
                        item.isLike
                          ? 'publicAction_curgoodicon'
                          : 'publicAction_goodicon'
                      "
                      ref="allReplyboxList_lickbtn"
                    ></div>
                    <span v-show="item.likeNum != 0">{{ item.likeNum }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div class="msgWrapbox" v-show="mongoliaFlag" @click="inputblur"></div>
    <div class="allReplyList_bottom">
      <label for="allReplybox_replyCon">
        <div
          class="msgCon"
          v-show="this.postingFlag"
          @click="toInputFocus(contentObj, 'poster')"
        >
          {{ this.canReply == 0 ? '说点什么...' : '已关闭回复' }}
        </div>
        <div
          class="msgCon"
          v-show="!this.postingFlag"
          @click="toInputFocus(contentObj, 'poster')"
        >
          {{ this.postingFlag ? '说点什么...' : '功能维护中，暂不支持回复' }}
        </div>
      </label>
      <div
        class="details_input_text"
        :class="replyValue == '' ? 'ash' : ''"
        @click="submit(1)"
      >
        發布
      </div>
    </div>
    <!-- 弹窗同步 -->
    <div class="msgWrapbox" v-show="mongoliaFlag" @click="inputblur"></div>
    <div
      class="allReplyList_bottombox"
      v-show="!bottomFlag"
      :class="
        emojiFlag && $padFalg == 'other'
          ? 'allReplyList_bottombox_emojicur'
          : ''
      "
    >
      <div class="msgWrap_bottombox2_top">
        <span v-if="msgToOther" class="msg_to"
          ><img :src="msgToOtherImg" alt=""
        /></span>
        <p class="msgWrap_bottombox2_top_span" v-html="msgTo"></p>
      </div>
      <div class="msgWrap_bottombox2_topbox">
        <van-field
          placeholder="说点什么..."
          v-model="replyValue"
          class="msgCon"
          id="allReplybox_replyCon"
          maxlength="1000"
          @focus="inputFocus('str')"
          ref="inpIngCon"
          rows="2"
          autosize
          label=""
          type="textarea"
          show-word-limit
        />
      </div>
      <div class="msgWrap_bottombox2_bottom">
        <div
          class="uploadPage_bottom_expression"
          :class="emojiFlag ? 'uploadPage_bottom_expressioncur' : ''"
          @mousedown="emojiClick"
        ></div>
        <div
          class="details_input_text"
          :class="replyValue == '' ? 'ash' : ''"
          @click="submit(1)"
        >
          發布
        </div>
      </div>
      <emjoy
        ref="emjoy"
        v-if="emojiFlag && $padFalg == 'other'"
        @pushvalue="pushvalue"
        @deleteClick="deleteClick"
      >
      </emjoy>
      <div class="pad_emjoy" v-if="emojiFlag && $padFalg != 'other'">
        <div class="pad_emjoybox">
          <emjoy
            ref="emjoy"
            @pushvalue="pushvalue"
            @deleteClick="deleteClick"
          ></emjoy>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import message from '../../message.vue';
import get from '@/api/get';
import { Toast } from 'vant';
import * as _code from '../../../utils/code';
import qs, { stringify } from 'qs';
import getTime from '@/utils/time';
import arrNewSet from '@/utils/arrNewSet';
import numberFormat from '@/utils/numberFormat';
import emjoy from '../../emjoy/emjoy.vue';
import levelIcon from '@/components/task/levelIcon.vue';

export default {
  name: 'allReplyList',
  components: { message, emjoy, levelIcon },
  props: {
    allReplyListId: {
      type: Number,
      default: 0
    },
    detailId: {
      type: String,
      default: '0'
    },
    canReply: {
      type: Number,
      default: 0
    },
    postsPosterId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      emojiFlag: false,
      poster: false, //判断是否恢复楼主
      defaultImg:
        this.$store.state.gameType != 1
          ? 'https://media.tentree-games.com/media/pictures/community/img/header.webp'
          : 'https://media.zlongame.com/media/pictures/cn/community/img/lzg_header.png',
      mongoliaFlag: false,
      objectsAre: '',
      replyValue: '',
      false: false,
      contentObj: {},
      likeMemberAvators: [],
      detailData: '',
      loading: false,
      finished: false,
      pageNo: 1,
      bottomFlag: true, //回复弹窗
      msgToOther: '',
      msgToOtherImg: '',
      msgTo: '',
      replyValue: '',
      replyItem: '',
      postingFlag: ''
    };
  },
  mounted() {
    this.init();
    this.postingFlag = this.$store.state.postingFlag;
  },
  methods: {
    //表情包功能模块
    deleteClick() {
      let _this = this;
      let len = `${_this.replyValue.match(
        /\[[\u4E00-\u9FA5]{1,3}_[\u4E00-\u9FA5]{1,3}_(\d){1,2}_(\d{1,3})\]$/g,
        function (a) {
          return a;
        }
      )}`.length;
      if (len == 4) {
        _this.replyValue = _this.replyValue.slice(0, -1);
      } else {
        _this.replyValue = _this.replyValue.slice(0, -len);
      }
    },
    pushvalue(imgvalue) {
      let _this = this;
      let elInput = document.getElementById('allReplybox_replyCon');
      let startPos = elInput.selectionStart;
      let endPos = elInput.selectionEnd;
      if (endPos === 0 && _this.replyValue == '') {
        _this.replyValue = this.$refs.emjoy.changeValue(imgvalue);
      } else {
        let txt = _this.replyValue;
        let result =
          txt.substring(0, startPos) +
          this.$refs.emjoy.changeValue(imgvalue) +
          txt.substring(endPos);
        _this.replyValue = result;
      }
      if (this.$padFalg != 'other') {
        this.emojiClick();
      }
      _this.$nextTick(() => {
        elInput.focus();
        elInput.selectionStart = startPos + _this.replyValue.length;
        elInput.selectionEnd = startPos + _this.replyValue.length;
      });
    },
    emojiClick() {
      this.emojiFlag = !this.emojiFlag;
    },
    init() {
      // 回帖内容-层主
      this.detail();
      // get.detail(this.allReplyListId).then((res) => {
      //   let data = res.data;
      //   if (data.code == 0) {
      //     get.replyList(this.allReplyListId).then((res) => {
      //       let _data = res.data;
      //       if (_data.code == 0) {
      //         this.contentObj = data.data;
      //         this.likeMemberAvators = JSON.parse(
      //           JSON.stringify(_data.data.list)
      //         );
      //       } else {
      //         this.errorMessage(_data);
      //       }
      //     });
      //   } else {
      //     this.errorMessage(data);
      //   }
      // });
    },
    defImg() {
      //图片错误展示默认图片
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    // 回帖内容-层主
    detail() {
      let _this = this;
      get.detail(this.allReplyListId).then((res) => {
        let data = res.data;
        _this.detailData = data;
        let _obj = [];
        _obj[0] = _this.detailData.data;
        getTime(_obj);
        if (data.code == 0) {
          _this.repylist();
        } else {
          this.errorMessage(data);
        }
      });
    },
    // 帖子评论详情
    repylist(cb) {
      let _this = this;
      let obj = {
        pageNo: _this.pageNo,
        pageSize: 10
      };
      get.replyList(this.allReplyListId, obj).then((res) => {
        let _data = res.data;
        if (_data.code == 0) {
          _this.contentObj = _this.detailData.data;
          _this.contentObj.likeNum = numberFormat(_this.contentObj.likeNum);
          _this.contentObj.replyNum = numberFormat(_this.contentObj.replyNum);
          if (_this.pageNo == 1) {
            _data.data.list.forEach((v, i) => {
              v.czFlag =
                _this.detailData.data.memberNickName == v.replyMemberNickName
                  ? true
                  : false;
            });
            getTime(_data.data.list);
            _this.likeMemberAvators = _data.data.list;
          }
          cb && cb(_data.data.list);
        } else {
          _this.errorMessage(_data);
        }
      });
    },
    onLoad() {
      let _this = this;
      setTimeout(() => {
        _this.pageNo++;
        _this.repylist(function (data) {
          getTime(data);
          _this.likeMemberAvators = _this.likeMemberAvators.concat(data);
          // _this.likeMemberAvators=Array.from(new Set(_this.likeMemberAvators));
          _this.likeMemberAvators = arrNewSet(_this.likeMemberAvators);
          _this.likeMemberAvators.forEach((n, i) => {
            n.likeNum = numberFormat(n.likeNum);
          });
          // 加载状态结束
          _this.loading = false;

          // 数据全部加载完成
          if (data.length < 10) {
            _this.finished = true;
            _this.pageNo--;
          }
        });
      }, 1000);
    },
    vueTouch(text, e) {
      this.finished = false;
      this.loading = true;
      setTimeout(() => {
        this.onLoad();
      }, 1000);
    },
    //扩展点击
    vanActionFlag(item) {
      this.$emit('vanActionFlag', 2, item);
    },
    likeChang(item) {
      item.isLike = !item.isLike;
      item.isLike ? item.likeNum++ : item.likeNum--;
      if (item.isLike && item.isBad) {
        this.badClick(item);
      }
    },
    //点赞
    lickClick(item, index) {
      console.log(item, index);
      get.commentLikeClick(item.id).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          if (data.message == '点赞成功') {
            if (index || index == 0) {
              this.$refs.allReplyboxList_lickbtn[index].style.width = '.8rem';
              this.$refs.allReplyboxList_lickbtn[index].style.height = '.8rem';
              this.$refs.allReplyboxList_lickbtn[
                index
              ].style.backgroundPosition = 'right';
              this.$refs.allReplyboxList_lickbtn[
                index
              ].style.transition = `background .6s steps(28)`;
              setTimeout(() => {
                this.$refs.allReplyboxList_lickbtn[index].style.width = '.8rem';
                ('.8rem');
                this.$refs.allReplyboxList_lickbtn[index].style.height =
                  '.8rem';
                ('.8rem');
                this.$refs.allReplyboxList_lickbtn[
                  index
                ].style.backgroundPosition = 'left';
                this.$refs.allReplyboxList_lickbtn[
                  index
                ].style.transition = `none`;
                this.likeChang(item);
              }, 600);
            } else {
              this.$refs.allReplybox_lickbtn.style.width = '.8rem';
              this.$refs.allReplybox_lickbtn.style.height = '.8rem';
              this.$refs.allReplybox_lickbtn.style.backgroundPosition = 'right';
              this.$refs.allReplybox_lickbtn.style.transition = `background .6s steps(28)`;
              setTimeout(() => {
                this.$refs.allReplybox_lickbtn.style.width = '.8rem';
                this.$refs.allReplybox_lickbtn.style.width = '.8rem';
                this.$refs.allReplybox_lickbtn.style.height = '.8rem';
                this.$refs.allReplybox_lickbtn.style.height = '.8rem';
                this.$refs.allReplybox_lickbtn.style.backgroundPosition =
                  'left';
                this.$refs.allReplybox_lickbtn.style.transition = `none`;
                this.likeChang(item);
              }, 600);
            }
          } else {
            this.likeChang(item);
          }
        } else {
          this.errorMessage(data);
        }
      });
    },
    //踩
    badClick(item) {
      get.commentBadClick(item.id).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          item.isBad = !item.isBad;
          if (item.isLike && item.isBad) {
            this.lickClick(item);
          }
        } else {
          // this.errorMessage(data);
        }
      });
    },
    backClick() {
      this.$emit('allReplyChang', false);
    },
    submit() {
      if (this.replyValue == '') {
        return;
      }
      let obj = {
        content: this.replyValue,
        commentId:
          this.objectsAre != '' ? this.contentObj.id : this.contentObj.id,
        replyMemberId: this.poster
          ? 0
          : this.objectsAre != ''
          ? this.objectsAre.memberId
          : this.contentObj.memberId
      };
      console.log(this.poster);
      get.topicComment(this.detailId, qs.stringify(obj)).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          Toast.success('發布成功');
          this.mongoliaFlag = this.false;
          this.replyValue = '';
          this.objectsAre = '';
          this.inputblur();
          // this.repylist();
          this.vueTouch();
        } else {
          this.errorMessage(data);
        }
      });
    },
    //去用户主页
    goUserPage(id) {
      this.$router.push({ name: 'otherHome', query: { id: id } });
    },
    //底部input获取焦点事件
    toInputFocus(obj, poster) {
      if (this.canReply != 0 || !this.postingFlag) return;
      if (poster == 'poster') {
        this.poster = true;
      } else {
        this.poster = this.false;
      }
      this.inputFocus(obj, 1);
      this.objectsAre = obj;
    },
    inputFocus(objectsAre, id) {
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
      }
      if (objectsAre !== 'str') {
        this.msgToOther = true;
        this.msgToOtherImg = objectsAre.memberAvatar;
        this.msgTo = objectsAre.content;
        this.mongoliaFlag = true;
        this.bottomFlag = false;
      }
    },
    //失去焦点
    inputblur() {
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
      }
      this.mongoliaFlag = false;
      this.bottomFlag = true;
      this.replyValue = '';
      this.$refs.inpIngCon.blur();
      this.emojiFlag = false;
    },
    focus() {},
    blur() {},
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>
<style scoped></style>
